// removed by extract-text-webpack-plugin
module.exports = {"slide":"_2HqbVe6Rty8DWhJjfuUjRK","slideText":"_1nsSQg2YYAEigAG3eRi_KJ","slideVideo":"_1qYyKqn4FkPJaieVbNDf1i"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/aboutUs/aboutUs.css
// module id = 101
// module chunks = 0